module.exports = __webpack_public_path__ + "img/high-five.2c0d27eb.svg";